import Icons_Dashboard_Active from "./Icons_Dashboard_Active.png";
import Icons_Dashboard_Inactive from "./Icons_Dashboard_Inactive.png";
import Icons_Organization_Active from "./Icons_Organization_Active.png";
import Icons_Surveys_Active from "./Icons_Surveys_Active.png";
import Icons_Surveys_Inactive from "./Icons_Surveys_Inactive.png";
import Icons_Organization_Inactive from "./Icons_Organization_Inactive.png";
import Icons_User_Active from "./Icons_User_Active.png";
import Icons_User_Inactive from "./Icons_User_Inactive.png";
import Icons_Control_library_active from "./Icons_Control_library_active.svg";
import Icons_Control_Library_inactive from "./Icons_Control_Library_inactive.svg";
import Icons_Employee_Control_Library from "./Icons_Employee_Control_Library.svg";
import ExportIcon from "./Icons_export.svg";
import AppLogo from "./app-logo.png";
import AppLogoMark from "./app-logo-mark.png";
import AssessmentAppLogo from "./pre-assessment-app-logo.png";
import Connector from "./connector.svg";
import Check from "./Check.svg";
import Icons_Organizations_active from "./Icons_Organizations_active.png";
import Icons_Organizations_inactive from "./Icons_Organizations_inactive.png";
import No_Assessments from "./No_Assessments.png";
import Download_icon from "./Download.svg";
import Create_Assessment_Icon from "./Create_Assessment_Icon.png";
import Party_Popper_Icon from "./party-popper.svg";
import Dotted_Check from "./Dotted-check.svg";
import Warning_Icon from "./Warning_Icon.svg";

const images = {
  Icons_Dashboard_Active,
  Icons_Dashboard_Inactive,
  Icons_Organization_Active,
  Icons_Surveys_Active,
  Icons_Surveys_Inactive,
  Icons_Organization_Inactive,
  Icons_User_Active,
  Icons_User_Inactive,
  Icons_Control_library_active,
  Icons_Control_Library_inactive,
  Icons_Employee_Control_Library,
  Icons_Organizations_active,
  Icons_Organizations_inactive,
  ExportIcon,
  AppLogo,
  AppLogoMark,
  AssessmentAppLogo,
  Connector,
  Check,
  No_Assessments,
  Download_icon,
  Create_Assessment_Icon,
  Party_Popper_Icon,
  Dotted_Check,
  Warning_Icon,
};
export default images;
